import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getFlexportIntegration = {
  name: "getFlexportIntegration" as const,
  input: z.object({}),
  output: z.object({
    flexportIntegration: z.optional(
      z.object({
        accessToken: z.string(),
        /** @deprecated Flexport location filtering has been removed; no longer used. */
        locations: z.array(zExt.objectId()),
      }),
    ),
  }),
};

export type GetFlexportIntegrationOutput = z.infer<
  typeof getFlexportIntegration.output
>;

export const putFlexportIntegration = {
  name: "putFlexportIntegration" as const,
  input: z.object({
    accessToken: z.string().optional(),
    /** @deprecated Flexport location filtering has been removed; no longer used. */
    locations: z.array(zExt.objectId()).optional(),
  }),
  output: z.object({}),
};

export type PutFlexportIntegrationInput = z.infer<
  typeof putFlexportIntegration.input
>;

export const disconnectFlexportIntegration = {
  name: "disconnectFlexportIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
